import { render, staticRenderFns } from "./MainInfo.vue?vue&type=template&id=57a547bc&scoped=true"
import script from "./MainInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MainInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MainInfo.vue?vue&type=style&index=0&id=57a547bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a547bc",
  null
  
)

export default component.exports